import React from "react";
import AnimatedSection from "../Shared/AnimatedSection";

const CyberAdmissionRequ = ({ componentData }) => {
  // Use componentData from CMS if available, otherwise use defaults
  const title = componentData?.title || "ADMISSION REQUIREMENTS";
  const content = componentData?.content || 
    "The applicant should posses at least four (4) passes in non religious subjects in the Certificate of Seconadary Education Examination (CSEE) OR should posses the National Vocational Award Level III (Trade Test Grade I) in a relevant field from a recognized institution.";

  return (
    <AnimatedSection title={title}>
      <p className="text-base md:text-lg lg:text-xl text-black leading-loose tracking-wide mb-8 whitespace-pre-line">
        {content}
      </p>
      <p className="text-base md:text-lg lg:text-xl text-gray-800 leading-loose tracking-wide border-l-4 border-gold pl-5 italic">
        Upon successful completion, students will be awarded a Certificate (1 Year) or Diploma (2 Years) as applicable, recognized by the relevant accreditation authorities in Tanzania.
      </p>
    </AnimatedSection>
  );
};

export default CyberAdmissionRequ;
